import React from "react";
import { Box, Skeleton, Divider } from "@mui/material";

const LeadDetailsSkeleton: React.FC = () => {
  return (
    <Box sx={{ paddingBottom: "10px", width: "100%" }}>
      <Box
        sx={{
          p: 2,
          display: "flex",
          alignItems: "center",
          gap: 2,
          background: "#fff",
        }}
      >
        <Skeleton variant="circular" width={32} height={32} />
        <Box sx={{ flexGrow: 1 }}>
          <Skeleton variant="text" width={200} height={32} />
          <Skeleton variant="text" width={300} height={24} />
        </Box>
      </Box>

      <Box
        sx={{ p: 2, display: "flex", gap: 1, justifyContent: "space-between" }}
      >
        <Box display="flex" gap={1}>
          {[1, 2, 3, 4, 5].map((i) => (
            <Skeleton key={i} variant="rounded" width={40} height={40} />
          ))}
        </Box>
        <Skeleton variant="rounded" width={120} height={40} />
      </Box>

      <Box sx={{ p: 2 }}>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <Skeleton variant="circular" width={56} height={56} />
          <Box sx={{ flexGrow: 1 }}>
            <Skeleton variant="text" width={250} height={32} />
            <Skeleton variant="text" width={200} height={24} />
            <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
              {[1, 2, 3].map((i) => (
                <Skeleton key={i} variant="rounded" width={80} height={24} />
              ))}
            </Box>
          </Box>
          <Box textAlign="center">
            <Skeleton variant="circular" width={48} height={48} />
            <Skeleton variant="text" width={80} height={24} />
          </Box>
        </Box>
      </Box>

      <Box sx={{ p: 2 }}>
        <Box sx={{ display: "flex", gap: 4 }}>
          <Skeleton variant="rounded" width={150} height={48} />
          <Skeleton variant="rounded" width={150} height={48} />
        </Box>
      </Box>

      <Box sx={{ p: 2 }}>
        <Box sx={{ mb: 3 }}>
          <Skeleton variant="rounded" height={60} sx={{ mb: 3 }} />

          {[1, 2, 3, 4, 5].map((i) => (
            <Box key={i} sx={{ display: "flex", py: 1.5 }}>
              <Skeleton variant="text" width={200} height={24} />
              <Skeleton variant="text" width={300} height={24} />
            </Box>
          ))}

          <Divider sx={{ my: 3 }} />

          {/* Skills */}
          <Box sx={{ mb: 4 }}>
            <Skeleton variant="text" width={100} height={32} sx={{ mb: 2 }} />
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
              {[1, 2, 3, 4, 5].map((i) => (
                <Skeleton key={i} variant="rounded" width={80} height={32} />
              ))}
            </Box>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Skeleton variant="text" width={150} height={32} sx={{ mb: 2 }} />
            {[1, 2].map((i) => (
              <Box key={i} sx={{ mb: 3 }}>
                <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                  <Skeleton variant="rounded" width={40} height={40} />
                  <Box sx={{ flexGrow: 1 }}>
                    <Skeleton variant="text" width={200} height={24} />
                    <Skeleton variant="text" width={300} height={20} />
                    <Skeleton variant="text" width={250} height={20} />
                  </Box>
                </Box>
                <Divider sx={{ mt: 2 }} />
              </Box>
            ))}
          </Box>

          <Box>
            <Skeleton variant="text" width={150} height={32} sx={{ mb: 2 }} />
            {[1, 2].map((i) => (
              <Box
                key={i}
                sx={{ mb: 3, display: "flex", gap: 2, alignItems: "center" }}
              >
                <Skeleton variant="rounded" width={40} height={40} />
                <Box sx={{ flexGrow: 1 }}>
                  <Skeleton variant="text" width={200} height={24} />
                  <Skeleton variant="text" width={300} height={20} />
                  <Skeleton variant="text" width={250} height={20} />
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LeadDetailsSkeleton;
